import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import styled from 'styled-components';
import { DatePicker, FocusedInputShape } from '@inplayer-org/inplayer-ui';
import moment from 'moment';

// types
import { DateInterval } from 'components/Modals/ReportModal';

// utils
import { format } from 'pages/MerchantPages/Analytics/Analytics';

// actions
import { fetchAssetPaymentPerCountry } from 'ducks/merchantDucks/payments/actions';

// components
import PaymentTiles from 'pages/MerchantPages/Assets/components/ItemAnalytics/PaymentTiles';

const DatePickerContainer = styled.div`
  > div {
    width: 100%;
  }
`;

const AssetAnalytics = () => {
  const dispatch = useDispatch();
  const { id } = useParams<{ id: string }>();

  const [startDate, setStartDate] = useState(moment().startOf('day').subtract(1, 'month'));
  const [endDate, setEndDate] = useState(moment().endOf('day'));
  const [focusedInput, setFocusedInput] = useState();

  useEffect(() => {
    dispatch(fetchAssetPaymentPerCountry(Number(id), startDate.format(format), endDate.format(format)));
  }, [startDate, endDate]);

  const onDateChange = ({ startDate: start, endDate: end }: DateInterval) => {
    if (start) setStartDate(start);
    if (end) setEndDate(end);
  };

  const onFocusChange = (focused: FocusedInputShape | null) => {
    setFocusedInput(focused);
  };

  return (
    <>
      <DatePickerContainer>
        <DatePicker
          startDate={startDate}
          endDate={endDate}
          onDateChange={onDateChange}
          onFocusChange={onFocusChange}
          focusedInput={focusedInput}
          minimumNights={0}
          showPresets
        />
      </DatePickerContainer>
      <PaymentTiles startDate={startDate} endDate={endDate} />
    </>
  );
};

export default AssetAnalytics;
